import { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { usePortalAuth } from './PortalAuthContext';
import { Button, Input } from '../design-system';
import './Portal.css';

// Client sign-in. Separate page and separate route from the staff /login so a
// client never lands on the firm's login form (and vice versa).
function PortalLogin() {
  const { login, user, loading } = usePortalAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  if (loading) return <div className="portal-boot">Loading…</div>;
  if (user) {
    return <Navigate to={user.mustChangePassword ? '/portal/set-password' : '/portal'} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const signedIn = await login(email.trim(), password);
      if (signedIn.mustChangePassword) {
        navigate('/portal/set-password', { replace: true });
      } else {
        navigate(location.state?.from || '/portal', { replace: true });
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Could not sign in. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="portal-auth-page">
      <form className="portal-auth-card" onSubmit={submit}>
        <h1 className="portal-auth-title">Client Portal</h1>
        <p className="portal-auth-sub">
          Sign in to share documents and talk to your accountant.
        </p>

        {error && <div className="portal-auth-error" role="alert">{error}</div>}

        <Input
          label="Email"
          type="email"
          autoComplete="username"
          autoFocus
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Input
          label="Password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <Button type="submit" variant="primary" loading={busy} disabled={!email || !password}>
          Sign in
        </Button>

        <p className="portal-auth-help">
          Don&apos;t have a login? Ask your accountant to set one up for you.
        </p>
      </form>
    </div>
  );
}

export default PortalLogin;
